import styled from 'styled-components/macro';
import { Box } from '@podiumhq/design-system';
import { Button, COLORS } from '@podiumhq/design-system';

export const GoogleAutocompleteResultsWrapper = styled(Box)`
  background-color: ${COLORS.silver.lightest};
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  left: 0;
  margin-bottom: 12px;
  margin-top: -24px;
  padding: 16px 0;
  position: absolute;
  right: 0;
  z-index: 9;
`;

export const GoogleAutocompleteResultsList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const GoogleAutocompletePredictionWrapper = styled.li`
  cursor: pointer;
  list-style: none;
  margin: 0 0 4px 0;
  padding: 10px 16px;

  &:last-child {
    margin-bottom: 14px;
  }

  &:hover,
  &:focus {
    outline: none;
    background: ${COLORS.silver.lighter};
  }
`;

export const GoogleAutocompleteResultsTitle = styled.h6`
  color: #333333;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
`;

export const GoogleAutocompleteResultsText = styled.small`
  color: ${COLORS.grey.light};
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 12px;
`;

export const GoogleAutocompleteResultsAddress = styled(
  GoogleAutocompleteResultsText
)`
  font-size: 14px;
  margin-bottom: 0;
`;

export const GoogleAutocompleteResultsLink = styled(Button)`
  display: inline;
  height: auto;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  vertical-align: revert;

  &:not([disabled]):active,
  &:not([disabled]):focus,
  &:not([disabled]):hover {
    background-color: transparent;
  }
`;

export const GoogleAutocompleteNoResultsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 0 50px 0;

  ${GoogleAutocompleteResultsLink} {
    font-size: 14px;
  }
`;

export const GoogleAutocompleteNoSearchResultsTitle = styled(
  GoogleAutocompleteResultsAddress
)`
  color: #333333;
  font-weight: 600;
  margin: 13px 0 10px 0;
  text-align: center;
`;

export const GoogleAutocompleteImage = styled.img`
  padding: 0 16px;
`;

export const googleAutocompleteResultsWrapperStyles = {
  backgroundColor: 'silver.lightest',
  borderRadius: '3px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  left: '0',
  marginBottom: '12px',
  marginTop: '-24px',
  padding: '16px 0',
  position: 'absolute',
  right: '0',
  zIndex: '9',
};

export const googleAutocompleteResultsTitleStyles = {
  color: '#333333',
  fontSize: '14px',
  fontWeight: 'semibold',
  margin: 0,
};

export const googleAutocompleteSmallTextStyles = {
  color: 'grey.light',
  display: 'inline-block',
  fontSize: 'sm',
  marginBottom: '12px',
};
